<template lang="pug">
.magic-properties(v-if="magicPropertiesWithMatches.length")
  .overline.mb-2 Magical Properties
  .magic-grid
    .magic-card(v-for="group in groupedProperties" :key="group.layerName")
      .magic-card-header
        v-icon(small :color="group.layerMatched ? 'success' : 'error'" :title="group.layerMatched ? 'Layer found' : 'Layer not found'") {{ group.layerMatched ? 'mdi-layers' : 'mdi-layers-off' }}
        span.caption.font-weight-bold.ml-1 {{ group.layerName }}
      .magic-card-attrs
        .d-flex.align-center.mb-1(v-for="prop in group.attributes" :key="prop.layerAttributeName")
          v-icon(x-small :color="prop.attributeMatchIcon === 'check' ? 'success' : 'grey'") {{ prop.attributeMatchIcon }}
          span.caption.grey--text.ml-1 {{ prop.layerAttributeName }}
</template>

<style scoped>
.magic-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 8px;
}
.magic-card {
  border: 1px solid rgba(128,128,128,0.2);
  border-radius: 6px;
  padding: 6px 8px;
}
.magic-card-header {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  padding-bottom: 4px;
  border-bottom: 1px solid rgba(128,128,128,0.15);
}
</style>

<script>
  import { groupBy, includes, keys, map } from 'lodash'
  import { mapGetters } from 'vuex'

  export default {
    props: [
      "magicProperties",
      "template"
    ],

    computed: {
      ...mapGetters(["searchLayers"]),

      magicPropertiesWithMatches() {
        return map(this.magicProperties, (property) => {
          const layerMatched = !!this.searchLayers({ name: property.layerName })[0]
          const matchedLayer = this.searchLayers({ name: property.layerName })[0]
          const attributeMatched = matchedLayer && includes(keys(matchedLayer), property.layerAttributeName)
          return {
            ...property,
            layerMatched,
            attributeMatchIcon: attributeMatched ? "check" : "cancel"
          }
        })
      },

      groupedProperties() {
        const grouped = groupBy(this.magicPropertiesWithMatches, "layerName")
        return map(grouped, (attributes, layerName) => ({
          layerName,
          layerMatched: attributes[0].layerMatched,
          attributes
        }))
      }
    }
  }
</script>
